import Immutable from 'immutable';
import { NewPunch } from 'records/NewPunch';

export interface CreatePunchData {
  type: string;
  index: number;
  expanded: boolean;
  viewerOverlay: boolean;
  punch: NewPunch;
  containerStyles: React.CSSProperties;
}

const defaultValues: CreatePunchData = {
  type: 'CreatePunch',
  index: 0,
  expanded: true,
  viewerOverlay: false,
  punch: new NewPunch(),
  containerStyles: {},
};

export const CreatePunchFactory = Immutable.Record(
  defaultValues,
  'CreatePunch'
);

export class CreatePunch extends CreatePunchFactory {}
